export default "__VITE_ASSET__C4z6d5Ot__"